import { ProductsStoreService } from '../../stores/products-store.service';
import { ChargingStationPricing } from '../../libs/feature-lib/charging-station/charging-station-pricing.service';
import { map, mergeMap } from 'rxjs/operators';
import { EvsbFinalInvoiceMapper } from './evsb-final-invoice.mapper';
import { EvsbFinalInvoiceModel } from './evsb-final-invoice.model';
import { Observable, combineLatest } from 'rxjs';
import { Injectable } from '@angular/core';
import { SmallBizStoreService } from '../../stores/small-biz-store.service';

@Injectable()
export class EvsbFinalInvoiceService {
  constructor(
    private mapper: EvsbFinalInvoiceMapper,
    private store: SmallBizStoreService,
    private chargingStationPricing: ChargingStationPricing,
    private productsStoreService: ProductsStoreService
  ) {}

  public getModel$(): Observable<EvsbFinalInvoiceModel> {
    return this.store.model$.pipe(
      mergeMap((model) =>
        combineLatest([
          this.productsStoreService.card$.pipe(map((card) => parseInt(card.price, 10))),
          this.chargingStationPricing.mininumPrice$(),
          this.chargingStationPricing.for$(model.chargingStationConfig),
          this.chargingStationPricing.breakdownFor$(model.chargingStationConfig),
        ]).pipe(
          map(([cardPrice, minCharginStationPrice, charginStationPrice, chargingStationBreakdown]) =>
            this.mapper.map({
              storeModel: model,
              cardPrice,
              charginStationPrice,
              minCharginStationPrice,
              chargingStationBreakdown,
            })
          )
        )
      )
    );
  }
}
